import analytics from "../../analytics/analytics.js";
import { mapPinType } from "../../constants/index.js";
import { expressDealHotelId } from "../../HotelComponent/useSetHotelPinOnMapHook.js";
import { validateHotelDetailsURL } from "../../utils/validateHotelDetailsURL.js";
import { mapManager } from "../Maps/googleMapManager.js";
import { inlineMetadataManager } from "./MetadataManager.js";
const getHotelDetailURL = (options)=>{
    const { checkIn, checkOut, hotelId } = options;
    if (checkIn && checkOut && hotelId) return `https://www.priceline.com/relax/at/${hotelId}from/${checkIn}/to/${checkOut}`;
    return `https://www.priceline.com/relax/at/${hotelId}`;
};
const locationMetadataLinkClickHandler = async (options)=>{
    const { pinsInCurrentLine, targetPin, setIsMapOpened, checkIn, checkOut, isExpressDeal } = options;
    const hotelOnMapList = inlineMetadataManager.getHotelOnMapList();
    if (targetPin?.type === mapPinType.HOTEL && targetPin?.hotelId && !isExpressDeal) {
        const hotelPin = hotelOnMapList?.find((p)=>{
            const hotel = p?.hotel;
            if (hotel?.hotelType !== 'SOPQ') return String(p?.hotel?.hotelId) === String(targetPin.hotelId);
            {
                const expressId = hotel?.hotelId || expressDealHotelId(hotel);
                return expressId === targetPin.hotelId;
            }
        });
        const hotelId = hotelPin?.hotelId || targetPin.hotelId;
        const hotelDetailsURL = hotelPin?.hotelDetailsURL || getHotelDetailURL({
            checkIn,
            checkOut,
            hotelId
        });
        analytics.log({
            label: 'HotelSearchResult',
            hotelId: hotelId,
            message: 'HOTEL_DETAIL_LINK_CLICKED',
            clickedOnPennMessage: 'Y'
        });
        const url = await validateHotelDetailsURL(hotelDetailsURL);
        if (url) return void window.open(url, '_blank');
    }
    setIsMapOpened(true);
    mapManager.addCallback(()=>{
        const pins = targetPin?.type === mapPinType.HOTEL ? pinsInCurrentLine.filter((p)=>p.type === mapPinType.HOTEL) : pinsInCurrentLine;
        mapManager.fitBoundsOnCurrentMap(pins).catch((e)=>{
            analytics.logError({
                loggedFrom: 'locationMetadataLinkClickHandler:fitBoundsOnCurrentMap',
                message: 'Failed to call fitBounds on map',
                error: e.message
            });
        });
    });
};
export { getHotelDetailURL, locationMetadataLinkClickHandler };
